import { z } from 'zod';
import { isValidPhoneNumber } from 'libphonenumber-js';

export const userDataSchema = z.object({
    first_name: z.string().min(1, 'First name is required'),
    last_name: z.string().min(1, 'Last name is required'),
    email: z.string().email('Invalid email address'),
});

export const phoneSchema = z.object({
    phone: z.string().refine((val) => isValidPhoneNumber(val), {
        message: 'Phone number is invalid',
    }),
});
